import { render, staticRenderFns } from "./CardCollectingItems.vue?vue&type=template&id=0ae79056&scoped=true"
import script from "./CardCollectingItems.vue?vue&type=script&lang=js"
export * from "./CardCollectingItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae79056",
  null
  
)

export default component.exports